
import { PageQuery } from '@/mixins/page_query';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { iRoomListQuery, iRoomListModel, eSearchStatus } from '@/interface/room-manage';
import { getRoomList, updateRoomClose, updateRoomTop, updateRoomTopCancel, updateTextForbidden } from '@/api/room-manage';
import { toast } from '@/utils/common';
import RejectDetail from './_RejectDetail.vue';
import { iCommandOperate } from '@/interface/result';

@Component({
  components: { RejectDetail },
})
export default class GameMarking extends Mixins(PageQuery) {
  loading: boolean = false;
  visibleDialog: boolean = false;
  game_id: number = 0;
  game_name: string = '';
  times: string = '';
  room_id: number = 0;
  private query: iRoomListQuery = {
    start: null,
    end: null,
    room_id: null,
    uid: null,
    nickname: '',
    search_status: eSearchStatus.NORMAL,
    reject_num: null,
    room_name: '',
  };
  private ids: Number[] = [];
  tableData: iRoomListModel[] = [];
  private dataValue: (string | Date)[] = [];
  normal: eSearchStatus = eSearchStatus.NORMAL;
  nospeak: eSearchStatus = eSearchStatus.NOSPEAK;
  close: eSearchStatus = eSearchStatus.CLOSE;
  searchStatusList = [
    {
      id: this.normal,
      name: '正常',
    },
    {
      id: this.nospeak,
      name: '禁言',
    },
    {
      id: this.close,
      name: '关闭',
    },
  ];
  handleSelectionChange(vals: iRoomListModel[]) {
    if (vals.length > 1) {
      this.ids = [];
      vals.forEach((el: iRoomListModel) => {
        this.ids.push(el.id);
      });
    } else if (vals.length === 0) {
      this.ids = [];
    } else {
      this.ids = [vals[0].id];
    }
  }
  handleClose() {
    this.visibleDialog = false;
  }
  goback() {
    this.$router.push({
      name: 'room-manage',
      params: {
        type: 'second',
      },
    });
  }
  dataChange(datavalue: Date[]) {
    if (!datavalue) {
      this.query.start = 0;
      this.query.end = 0;
      this.search();

      return;
    }
    this.query.start = Math.floor(datavalue[0].getTime() / 1000);
    this.query.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.search();
  }
  search() {
    this.page_query.page = 1;
    this.getSearchList();
  }
  getSatatus(type: number) {
    return type === 5 ? '1' : '0';
  }
  goAction(row: iRoomListModel, type: string) {
    /* 警告 */
    if (type === 'jinggao') {
      this.visibleDialog = true;
      this.room_id = row.id;
    } else if (type === 'jingyan') {
      /* 禁言，取消禁言 */
      this.ids = [row.id];
      this.handleForbidden(row.is_forbidden_text ? this.normal : this.nospeak);
    } else if (type === 'zhiding') {
      /* 置顶 */
      this.room_id = row.id;
      this.updateRoomTop(row.is_top);
    } else if (type === 'close') {
      /* 关闭房间 */

      //  1-已创建 2-已排队 3已直播 4-待关闭 5-已关闭
      if (row.status === 5) {
        toast('已关闭的房间，不允许再次开启!', 'info');
        return;
      }
      this.ids = [row.id];
      this.updateRoomClose();
    }
  }
  async updateRoomTop(is_top: boolean) {
    try {
      let res = null;
      if (is_top) {
        res = await updateRoomTopCancel({ room_id: this.room_id });
      } else {
        res = await updateRoomTop({ room_id: this.room_id });
      }
      if (res.code === 0) {
        toast('操作成功！');
        this.getSearchList();
      } else {
        toast('操作失败,' + res.msg, 'error');
      }
    } catch (err) {
      console.log(err);
    }
  }
  async getSearchList() {
    try {
      this.loading = true;
      if (this.game_id) {
        this.query.game_id = this.game_id;
      }
      const res = await getRoomList({ ...this.page_query, ...this.query });
      this.tableData = res.data.list;
      this.total = res.data.total;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  /**
   * 处理下拉菜单的批量事件
   */
  handleBatch(command: iCommandOperate) {
    if (!this.ids.length) {
      toast('请勾选需要操作的房间', 'warning');
      return;
    }
    //关闭
    if (command.id === this.close) {
      this.updateRoomClose();
    } else {
      //解除禁言 or    //禁言
      this.handleForbidden(command.id);
    }
  }
  handleClick() {
    this.times = (document.getElementById('hinput') as HTMLInputElement).value;
  }
  handleForbidden(type: eSearchStatus) {
    if (type == this.normal) {
      this.updateTextForbidden(type);
      return;
    }
    const h = this.$createElement;
    this.clear();
    let that = this;
    this.$msgbox({
      title: '禁言',
      message: h('p', [
        h('span', '时长: '),
        h('input', {
          attrs: {
            class: 'comfim-input',
            value: that.times,
            placeholder: '输入禁言时长',
            id: 'hinput',
          },
          on: {
            input: this.handleClick,
          },
        }),
        h('span', '分钟 '),
        h('div', '填0，则是一直禁言 '),
      ]),

      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      center: true,
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          var str = this.times;
          var reg = new RegExp(/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/);
          if (!reg.test(str) || str.trim() == '') {
            toast('时长必须是大于等于0的数字', 'error');
            return;
          } else {
            done();
          }
        } else if (action === 'cancel') {
          done();
        }
      },
    })
      .then(action => {
        this.updateTextForbidden(type);
      })
      .finally(() => {
        this.ids = [];
      });
  }
  clear() {
    const doc = document.getElementById('hinput') as HTMLInputElement;
    if (doc) {
      doc.value = '';
    }

    this.times = '';
  }
  async updateTextForbidden(type: number) {
    try {
      const forbidden = type == this.normal ? false : true;
      const forbidden_min = type == this.nospeak ? JSON.parse(this.times) : 0;
      const res = await updateTextForbidden({ room_id: this.ids, forbidden, forbidden_min });
      if (res.code === 0) {
        toast('操作成功！');
        this.getSearchList();
      } else {
        toast('操作失败,' + res.msg, 'error');
      }
    } catch (err) {
      console.log(err);
    }
  }
  async updateRoomClose() {
    try {
      this.$msgbox({
        title: '提示',
        message: '确认关闭房间吗？',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            this.loading = true;
            const res = await updateRoomClose({ room_id: this.ids });
            if (res.code === 0 && res.data.failure.length === 0) {
              toast('操作成功！');
              this.getSearchList();
              this.ids = [];
            } else {
              let error = '';
              res.data.failure.map((item: any) => {
                error += 'room_id:' + item.room_id + item.reason + '; <br/>';
              });
              toast('操作失败! <br/>' + error, 'error', 2000, 150, true);
            }
            done();
            instance.confirmButtonLoading = false;
          } else if (action === 'cancel') {
            done();
            instance.confirmButtonLoading = false;
          }
        },
      }).finally(() => {
        this.loading = false;
      });
    } catch (err) {
      console.log(err);
    }
  }
  mounted() {
    if (this.$route.params && this.$route.params.game_id) {
      this.game_id = JSON.parse(this.$route.params.game_id);
      this.game_name = this.$route.params.game_name;
    }
    this.pageFn = this.getSearchList;
    this.getSearchList();
  }
}
